module.exports = __webpack_public_path__ + "img/bitcoin.8dda6e64.png";